import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const DisclaimerModal = () => {
  const [showDisclaimer, setShowDisclaimer] = useState(true);
  const [agreed, setAgreed] = useState(false);
 

  // Check if user has already agreed
  useEffect(() => {
    const hasAgreed = sessionStorage.getItem('disclaimerAgreed');
    if (hasAgreed === 'true') {
      setAgreed(true);
      setShowDisclaimer(false);
   
    }
  }, []);

  const handleAgree = () => {
    setAgreed(true);
    sessionStorage.setItem('disclaimerAgreed', 'true');
    setShowDisclaimer(false);
  };

  const handleDisagree = () => {
    setShowDisclaimer(false);
    window.location.href = 'https://www.google.com';
   
  };

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: {
        type: "spring",
        damping: 25,
        stiffness: 300
      }
    },
    exit: { 
      opacity: 0, 
      scale: 0.8,
      transition: {
        duration: 0.3
      }
    }
  };

  const backdropVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  return (
    <>
      {/* Disclaimer Modal */}
      <AnimatePresence>
        {showDisclaimer && (
          <motion.div
            className="modal fade show d-block"
            style={{ background: 'rgba(0, 0, 0, 0.7)' }}
            variants={backdropVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
          >
            <motion.div
              className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
              variants={modalVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '12px' }}>
                {/* Modal Header */}
                <div className="modal-header border-bottom-0 py-4 px-4" 
                  style={{ backgroundColor: 'var(--primary-blue)', color: 'var(--cream)' }}>
                  <h5 className="modal-title fw-bold d-flex align-items-center">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    Important Legal Disclaimer
                  </h5>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={handleDisagree}
                    aria-label="Close"
                  ></button>
                </div>

                {/* Modal Body */}
                <div className="modal-body p-4" style={{ maxHeight: '60vh' }}>
                  <div className="border-start border-3 border-warning ps-3 mb-4">
                    <p className="mb-2 fw-semibold" style={{ color: 'var(--primary-blue)' }}>
                      As per the rules of the Bar Council of India, Advocates are prohibited from advertising or soliciting work.
                    </p>
                    <p className="mb-0 text-muted">
                      This website is meant solely for the purpose of information and not for the purpose of advertising.
                    </p>
                  </div>

                  <div className="mb-4">
                    <h6 className="fw-bold mb-3" style={{ color: 'var(--primary-dark)' }}>
                      Please Read Carefully:
                    </h6>
                    
                    <ul className="list-unstyled ps-0">
                      <li className="mb-3 d-flex">
                        <i className="bi bi-circle-fill me-2 mt-1" style={{ fontSize: '6px', color: 'var(--gold)' }}></i>
                        <span>This website is for informational purposes only and not for advertising</span>
                      </li>
                      <li className="mb-3 d-flex">
                        <i className="bi bi-circle-fill me-2 mt-1" style={{ fontSize: '6px', color: 'var(--gold)' }}></i>
                        <span>RNA Law Chambers does not intend to solicit clients through this website</span>
                      </li>
                      <li className="mb-3 d-flex">
                        <i className="bi bi-circle-fill me-2 mt-1" style={{ fontSize: '6px', color: 'var(--gold)' }}></i>
                        <span>No attorney-client relationship is created by accessing this website</span>
                      </li>
                      <li className="mb-3 d-flex">
                        <i className="bi bi-circle-fill me-2 mt-1" style={{ fontSize: '6px', color: 'var(--gold)' }}></i>
                        <span>Information provided should not be construed as legal advice</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-light p-3 rounded-3 mb-4">
                    <p className="mb-2 fw-semibold" style={{ color: 'var(--primary-blue)' }}>
                      By clicking "I Agree", you acknowledge that:
                    </p>
                    <ol className="mb-0 ps-3">
                      <li className="mb-2">You are seeking information about RNA Law Chambers of your own accord</li>
                      <li className="mb-2">There has been no advertisement, solicitation, or inducement from RNA Law Chambers</li>
                      <li className="mb-2">Information is for informational purposes only, not legal advice</li>
                      <li>RNA Law Chambers is not liable for any consequence of action taken relying on this information</li>
                    </ol>
                  </div>
                </div>

                {/* Modal Footer */}
                <div className="modal-footer border-top-0 py-4 px-4" 
                  style={{ backgroundColor: 'rgba(var(--primary-blue-rgb), 0.05)' }}>
                  <div className="d-flex flex-column flex-sm-row w-100 gap-3">
                    <motion.button
                      type="button"
                      className="btn flex-fill px-4 py-2"
                      style={{
                        backgroundColor: '#e2e8f0',
                        color: '#64748b',
                        border: '1px solid #cbd5e1',
                        borderRadius: '8px',
                        fontWeight: '500'
                      }}
                      onClick={handleDisagree}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <i className="bi bi-x-lg me-2"></i>
                      Disagree & Leave
                    </motion.button>
                    <motion.button
                      type="button"
                      className="btn flex-fill px-4 py-2"
                      style={{
                        backgroundColor: 'var(--gold)',
                        color: 'var(--primary-dark)',
                        borderRadius: '8px',
                        fontWeight: '600'
                      }}
                      onClick={handleAgree}
                      whileHover={{ 
                        scale: 1.02,
                        backgroundColor: 'var(--primary-blue)',
                        color: 'var(--cream)'
                      }}
                      whileTap={{ scale: 0.98 }}
                    >
                      <i className="bi bi-check-lg me-2"></i>
                      I Agree & Continue
                    </motion.button>
                  </div>
                  
                  <div className="text-center mt-3 w-100">
                    <small className="text-muted">
                      <i className="bi bi-info-circle me-1"></i>
                      Your agreement will be stored in your browser for 30 days
                    </small>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      
    </>
  );
};

export default DisclaimerModal;